import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue'
import ModalForm from './components/ModalForm.vue'
import { getAppVersion } from '@/api/systemSetting/index'
import type { AppVersionItem } from '@/typings/api/systemSetting'


const __default__ = { name: 'DcCosSystemMapManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const modalFormRef = ref<any>()
const columns = computed(() => [
  {
    title: '操作系统',
    dataIndex: 'osType'
  },
  { title: '当前版本', dataIndex: 'currVersion' },
  { title: '最小版本号', dataIndex: 'minVersion' },
  { title: '最大版本号', dataIndex: 'maxVersion' },
  { title: '内容', dataIndex: 'content' },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'operationTime', width: 190 },

  {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    fixed: 'right'
  }
])

const getList = (queryForm: object, callBack: (res: any) => void) => {
  getAppVersion().then((res) => {
    callBack(res)
  })
}
const fetchTable = () => tableRef.value.fetch()
const handleEdit = (rows: AppVersionItem) => {
  modalFormRef.value?.init(rows)
}

return (_ctx: any,_cache: any) => {
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              columns: columns.value,
              onFetch: getList,
              ref_key: "tableRef",
              ref: tableRef,
              needPage: false,
              tableId: "DcCosSystemAppVersion"
            }, {
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createBlock(_component_dc_status, {
                      key: 0,
                      enums: _ctx.statusEnum,
                      value: text
                    }, null, 8, ["enums", "value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "link",
                      onClick: ($event: any) => (handleEdit(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'sys_app_version_edit_btn']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ModalForm, {
      ref_key: "modalFormRef",
      ref: modalFormRef,
      onFetch: fetchTable
    }, null, 512)
  ], 64))
}
}

})